



























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { PulldownItem } from "@/types";
@Component
export default class OtherMedical1 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() visit_count_items!: PulldownItem[]; //訪問回数アイテムリスト
  @Prop() indicate_day_items!: PulldownItem[]; //特指示アイテムリスト
  @Prop() long_day_items!: PulldownItem[]; //長時間アイテムリスト
  @Prop() multi_day_items!: PulldownItem[]; //複数日アイテムリスト
  @Prop() same_building_day_items!: PulldownItem[]; //同一建物アイテムリスト
  @Prop() same_emergency_day_items!: PulldownItem[]; //同一緊急アイテムリスト
  @Prop() special_day_items!: PulldownItem[]; //同一緊急アイテムリスト
}
